module.exports = __webpack_public_path__ + "media/theme/icon__status--voided-c0a4eed2.svg";